import React from 'react';
import { Application } from '@yulintu/freesia-bootstrap';

const Icon = function (props) {
    return <Application.SvgIcon type="user-settings-line" style={{ fontSize: 25 }} />;
}

export default Icon;